// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"eb8b2fb5","748":"6d07088b","885":"a12e4e52","977":"32ea642c"}[chunkId] + ".chunk.js";
};